module.exports = __webpack_public_path__ + "static/img/77021A_2_3_R_20180428_n_LC.ee078ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77021A_2_3_R_20180428_n_LC.png
// module id = sgvv
// module chunks = 0